function navigation(slider) {
    let wrapper, dots, arrowLeft, arrowRight
  
    function markup(remove) {
      wrapperMarkup(remove)
      dotMarkup(remove)
      arrowMarkup(remove)
    }
  
    function removeElement(elment) {
      elment.parentNode.removeChild(elment)
    }
    function createDiv(className) {
      var div = document.createElement("div")
      var classNames = className.split(" ")
      classNames.forEach((name) => div.classList.add(name))
      return div
    }
  
    function arrowMarkup(remove) {
      if (remove) {
        removeElement(arrowLeft)
        removeElement(arrowRight)
        return
      }
      arrowLeft = createDiv("arrow arrow--left product-images__arrow--left")
      arrowLeft.setAttribute('role', "button");
      arrowLeft.setAttribute('aria-label', "Previous slide");
      arrowLeft.setAttribute('tabindex', "0");
      window.productImagesArrowLeft = arrowLeft;
      arrowLeft.addEventListener("click", () => slider.prev())
      arrowRight = createDiv("arrow arrow--right plug-product-images__arrow--right")
      arrowRight.setAttribute('role', "button");
      arrowRight.setAttribute('aria-label', "Next slide");
      arrowRight.setAttribute('tabindex', "0");
      window.productImagesArrowRight = arrowRight;
      arrowRight.addEventListener("click", () => slider.next())
  
      document.querySelector(".product-images__thumbs-nav-wrapper").appendChild(arrowLeft)
      document.querySelector(".product-images__thumbs-nav-wrapper").appendChild(arrowRight)
    }
  
    function wrapperMarkup(remove) {
      if (remove) {
        var parent = wrapper.parentNode
        while (wrapper.firstChild)
          parent.insertBefore(wrapper.firstChild, wrapper)
        removeElement(wrapper)
        return
      }
      wrapper = createDiv("navigation-wrapper")
      slider.container.parentNode.appendChild(wrapper)
      wrapper.appendChild(slider.container)
    }
  
    function dotMarkup(remove) {
      if (remove) {
        removeElement(dots)
        return
      }
      dots = createDiv("dots")
      slider.track.details.slides.forEach((_e, idx) => {
        var dot = createDiv("dot")
        dot.addEventListener("click", () => slider.moveToIdx(idx))
        dots.appendChild(dot)
      })
      wrapper.appendChild(dots)
    }
  
    function updateClasses() {
      slider.track.details.minIdx === slider.track.details.abs
        ? arrowLeft.classList.add("arrow--disabled")
        : arrowLeft.classList.remove("arrow--disabled")
      slider.track.details.maxIdx === slider.track.details.abs
        ? arrowRight.classList.add("arrow--disabled")
        : arrowRight.classList.remove("arrow--disabled")
    }
  
    slider.on("created", () => {
      markup()
      updateClasses()
    })
    slider.on("optionsChanged", () => {
      console.log(2)
      markup(true)
      markup()
      updateClasses()
    })
    slider.on("slideChanged", () => {
      console.log(2)
      updateClasses()
    })
    slider.on("destroyed", () => {
      markup(true)
    })
    
  }
  
  function ThumbnailPlugin(main) {
      return (slider) => {
          function removeActive() {
              slider.slides.forEach((slide) => {
                  slide.classList.remove("active")
              })
          }
          function addActive(idx) {
              slider.slides[idx].classList.add("active")
              var arrowLeft = window.productImagesArrowLeft
              var arrowRight = window.productImagesArrowRight
              if (arrowLeft) {
                idx === 0
                ? arrowLeft.classList.add("arrow--disabled")
                : arrowLeft.classList.remove("arrow--disabled")
                idx === slider.track.details.slides.length - 1
                ? arrowRight.classList.add("arrow--disabled")
                : arrowRight.classList.remove("arrow--disabled")
              }
          }

          function addClickEvents() {
              slider.slides.forEach((slide, idx) => {
                  slide.addEventListener("click", () => {
                  main.moveToIdx(idx)
                  })
              })
          }

          slider.on("created", () => {
              addActive(slider.track.details.rel)
              addClickEvents()
              main.on("animationStarted", (main) => {
                  removeActive()
                  const next = main.animator.targetIdx || 0
                  addActive(main.track.absToRel(next))
              })
          })

          navigation(slider);
      }
  }

    
    
  var slider = new KeenSlider("[data-product-main-images]", {})
  var thumbnails = new KeenSlider(
      "[data-product-thumb-images]",
      {
          initial: 0,
          slides: {
          perView: 4,
          spacing: 0,
          },
      },
      [ThumbnailPlugin(this.slider)]
  )